import NotificationManagementBaseController from '../common/notification_management.base.controller'

class notificationManagementEditController extends NotificationManagementBaseController {
    /*@ngInject*/
    constructor(Auth, $state, User, Modal, $translate, $stateParams, $q) {
        super();
        // super(Auth, $state, User, NotificationManagementService, Modal, $translate, $stateParams)
        this.$stateParams = $stateParams;
        this.$q = $q;
        this.User = User;
        this.hasACL = {};
        this.rawId = '';

        this.defaultModel = {};
        this.loading = false;
        this.model = angular.copy(this.defaultModel);
        this.branchId = this.User.getUser().branchId;
    }

    $onInit() {
    }

    reset() {

    }

    submit() {
    }
}

export default notificationManagementEditController;


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/notification_management/edit/notification_management.edit.controller.js